export default function mediaItemList() {
  return {
    _id: false,
    type: 'droplet.mediaItemList',
    mediaQueries: [],
    visible: 6,
    showImage: true,
    loadMoreText: 'Load More',
    pageCSS: '',
    bounceDroplet: false,
    sortKey: 'released.date',
    isShared: false,
    templateRegion: false,
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/media-item-list/droplet.schema.js